export enum Roles {
  Admin = 'admin',
  ManageUsers = 'manage users',
  ManageSettings = 'manage settings',
  ManageImportExport = 'data import && export',
  ManagePost = 'manage post',
}

export enum Permissions {
  ManageUsers = 'Manage Users',
  ManagePosts = 'Manage Posts',
  ManageSettings = 'Manage Settings',
  ManageCollections = 'Manage Collections and Saved Searches',
  ImportExport = 'Bulk Data Import and Export',
  EditOwnPosts = 'Edit Their Own Posts',
  DeletePosts = 'Delete Posts',
  DeleteOwnPosts = 'Delete Their Own Posts',
  // Liberia PBO custom permission — gates the Analysis dashboard/templates feature.
  AccessAnalysis = 'Access analysis',
  // Liberia PBO custom permission — gates setting the admin-only Incident Status field.
  SetIncidentStatus = 'Set incident status',
}
